import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
export default function HorziBarChartsMain({ barcolor1,barcolor2, xAxisDataKey, barData, heading ,dataKeyName1,dataKeyName2,LegendLeft,LegendRight,customHeight="300px" }) {
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5 style={{fontSize:'16px'}}><b>{heading}</b></h5>
                    </div>
                </div>
                 <div style={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: barcolor1, width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{LegendLeft}</h5>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: barcolor2,  width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{LegendRight}</h5>
                    </div>
                </div>
                <div style={{height:customHeight}}>
                <ResponsiveContainer width="100%" height="100%">
                <BarChart
                   
                    responsive
                    data={barData}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey={xAxisDataKey} />
                    <YAxis  />
                    <Tooltip />
                    {/* <Legend /> */}
                    <Bar dataKey={dataKeyName1} fill={barcolor1} radius={[10, 10, 0, 0]} />
                    <Bar dataKey={dataKeyName2} fill={barcolor2} radius={[10, 10, 0, 0]} />


                </BarChart>
                </ResponsiveContainer>
                </div>
            </div>
        </>
    )
}
